import { render, staticRenderFns } from "./newschedulhead.vue?vue&type=template&id=4ec84daa&scoped=true"
import script from "./newschedulhead.vue?vue&type=script&lang=js"
export * from "./newschedulhead.vue?vue&type=script&lang=js"
import style0 from "./newschedulhead.vue?vue&type=style&index=0&id=4ec84daa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec84daa",
  null
  
)

export default component.exports